import { API } from '@/api';
import { StatusType, UpdateUserPayload } from '@/types';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getUsers = createAsyncThunk(
  'users/list',
  async ({
    currentPage,
    limit,
    sortBy,
    sortOrder,
    searchQuery,
  }: {
    currentPage: number;
    limit: number;
    sortBy: 'email' | 'timeJoined' | 'lastLoggedIn';
    sortOrder: 'asc' | 'desc';
    searchQuery: string;
  }) => API.usersManage.list({ currentPage, limit, sortBy, sortOrder, searchQuery }),
);

export const getAllUsersForExport = createAsyncThunk('users/getAllForExport', async () =>
  API.usersManage.getAll(),
);

export const updateUser = createAsyncThunk(
  'users/update',
  async ({ userId, field, value }: UpdateUserPayload) => {
    const response = await API.usersManage.update({
      userId,
      ...(field === 'accountStatus' && { newStatus: value as StatusType }),
      ...(field === 'organization' && { newOrg: value }),
    });
    return response;
  },
);

export const checkPendingUsers = createAsyncThunk('users/checkPending', async () => {
  const response = await API.usersManage.checkPending();
  return response;
});

export const reset2FA = createAsyncThunk('users/reset2FA', async (userId: string) => {
  const response = await API.usersManage.reset2FA(userId);
  return response;
});
